export const LOCAL_STORAGE_USER_KEY = 'user';
export const LOCAL_STORAGE_INGRESS_PATH_KEY = 'ingress-path';
export const LOCAL_STORAGE_UTM_TAGS_KEY = 'utm-tags';
